import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VAutocomplete,
    _vm._g(
      _vm._b(
        {
          ref: "time",
          staticStyle: { width: "130px" },
          attrs: {
            outlined: "",
            "menu-props": "auto",
            items: _vm.items,
            "item-text": "text",
            "item-value": "value",
          },
          on: { "update:search-input": _vm.onSearchInput },
          model: {
            value: _vm.dValue,
            callback: function ($$v) {
              _vm.dValue = $$v
            },
            expression: "dValue",
          },
        },
        "v-autocomplete",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }